import React, { useState } from 'react';
import { Button, Flex, Input, Table, Typography, type TableColumnsType } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { IQueryFieldsItem } from 'src/interfaces/entities/observer';

export interface IEditableTableProps {
	queryFields: (IQueryFieldsItem & { value?: string })[];
	onChange: (value: ITableType[]) => void;
}

interface ITableType {
	id: string;
	[key: string]: string;
}

const EditableTable = ({ queryFields, onChange, }: IEditableTableProps) => {
	const [ tableData, setTableData, ] = useState<ITableType[]>([]);

	const handleCellChange = (rowId: string, field: string, value: string) => {
		const updatedData = tableData.map((row) => {
			if (row.id === rowId) {
				return { ...row, [field]: value, };
			}
			return row;
		});
		setTableData(updatedData);
	};

	const columns = React.useMemo<TableColumnsType<ITableType>>(
		() => [
			...queryFields.map((item) => ({
				dataIndex: item.field,
				title: item.field,
				key: item.field,
				render: (value: string, record: ITableType) => (
					<Input
						value={value}
						onChange={(e) => handleCellChange(record.id, item.field, e.target.value)}
						variant="borderless"
						size="small"
					/>
				),
			})),
			{
				title: '',
				key: 'remove',
				width: 48,
				render: (_, record) => (
					<Button
						size="small"
						icon={<MinusOutlined />}
						onClick={() =>
							setTableData((prev) =>
								prev.filter((row) => row.id !== record.id)
							)
						}
					/>
				),
			},
		],
		[ queryFields, tableData, ]
	);

	const sampleRow: ITableType = {
		...queryFields.reduce(
			(acc, item) => ({ ...acc, [item.field]: '', }),
			{}
		),
		id: Math.random().toString(),
	};

	React.useEffect(() => {
		onChange && onChange(tableData);
	}, [ tableData, ]);

	return (
		<Flex style={{ width: '100%', height: '100%', maxHeight: '100%', }} vertical gap={8}>
			<Button
				type={'text'}
				icon={<PlusOutlined />}
				onClick={() => setTableData((prev) => [ ...prev, sampleRow, ])}
				style={{ alignSelf: 'flex-start', }}
			>
Adicionar Linha
			</Button>
			<Table<ITableType>
				columns={columns}
				dataSource={tableData}
				rowKey="id"
				size="small"
				pagination={false}
				scroll={{ y: 250, }}
				locale={{
					emptyText: (
						<Typography.Text
							style={{
								minHeight: '100%',
								display: 'flex',
								justifyContent: 'center',
							}}
						>
Adicione linhas para simular os dados!
						</Typography.Text>
					),
				}}
			/>
		</Flex>
	);
};

export default EditableTable;
